import React, { createContext } from 'react';

export interface KeycloakUser {
  _isAuthor: boolean;
  _isOwner: boolean;
  _isBHTConsultant: boolean;
  [key: string]: any;
}

export const UserContext = createContext<KeycloakUser>({
  _isAuthor: false,
  _isOwner: false,
  _isBHTConsultant: false,
});

export type UserProviderProps = {
  children: React.ReactNode;
  user: KeycloakUser;
};

export const UserProvider: React.FC<UserProviderProps> = ({
  children,
  user,
}) => {
  return (
    <UserContext.Provider value={{ ...user }}>{children}</UserContext.Provider>
  );
};
